<template>
  <!--浙江省体育职业技术学院（萧山校区）电气一次图-->
  <div class="onceItem1">
    <div class="onceImgBgc">
      <div class="bgcImg">
        <img alt="" class="bgc" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/onceImg/onceItem1.png">
        <div class="tablePox">
          <div class="tableItem">
            <table>
              <tr>
                <td>Ua</td>
                <td>{{ data.data1.ua }}</td>
                <td>KV</td>
              </tr>
              <tr>
                <td>Ub</td>
                <td>{{ data.data1.ub }}</td>
                <td>KV</td>
              </tr>
              <tr>
                <td>Uc</td>
                <td>{{ data.data1.uc }}</td>
                <td>KV</td>
              </tr>
            </table>
            <table>
              <tr>
                <td>Ua</td>
                <td>{{ data.data2.ua }}</td>
                <td>KV</td>
              </tr>
              <tr>
                <td>Ub</td>
                <td>{{ data.data2.ub }}</td>
                <td>KV</td>
              </tr>
              <tr>
                <td>Uc</td>
                <td>{{ data.data2.uc }}</td>
                <td>KV</td>
              </tr>
            </table>
            <table>
              <tr>
                <td>Ua</td>
                <td>{{ data.data3.ua }}</td>
                <td>KV</td>
              </tr>
              <tr>
                <td>Ub</td>
                <td>{{ data.data3.ub }}</td>
                <td>KV</td>
              </tr>
              <tr>
                <td>Uc</td>
                <td>{{ data.data3.uc }}</td>
                <td>KV</td>
              </tr>
            </table>
            <table>
              <tr>
                <td>Ua</td>
                <td>{{ data.data4.ua }}</td>
                <td>KV</td>
              </tr>
              <tr>
                <td>Ub</td>
                <td>{{ data.data4.ub }}</td>
                <td>KV</td>
              </tr>
              <tr>
                <td>Uc</td>
                <td>{{ data.data4.uc }}</td>
                <td>KV</td>
              </tr>
            </table>
            <table>
              <tr>
                <td>Ua</td>
                <td>{{ data.data5.ua }}</td>
                <td>KV</td>
              </tr>
              <tr>
                <td>Ub</td>
                <td>{{ data.data5.ub }}</td>
                <td>KV</td>
              </tr>
              <tr>
                <td>Uc</td>
                <td>{{ data.data5.uc }}</td>
                <td>KV</td>
              </tr>
            </table>
            <table>
              <tr>
                <td>Ua</td>
                <td>{{ data.data6.ua }}</td>
                <td>KV</td>
              </tr>
              <tr>
                <td>Ub</td>
                <td>{{ data.data6.ub }}</td>
                <td>KV</td>
              </tr>
              <tr>
                <td>Uc</td>
                <td>{{ data.data6.uc }}</td>
                <td>KV</td>
              </tr>
            </table>
            <table>
              <tr>
                <td>Ua</td>
                <td>{{ data.data7.ua }}</td>
                <td>KV</td>
              </tr>
              <tr>
                <td>Ub</td>
                <td>{{ data.data7.ub }}</td>
                <td>KV</td>
              </tr>
              <tr>
                <td>Uc</td>
                <td>{{ data.data7.uc }}</td>
                <td>KV</td>
              </tr>
            </table>
          </div>
          <div class="tableItem">
            <table>
              <tr>
                <td>Aa</td>
                <td>{{ data.data1.aa }}</td>
                <td>A</td>
              </tr>
              <tr>
                <td>Ab</td>
                <td>{{ data.data1.ab }}</td>
                <td>A</td>
              </tr>
              <tr>
                <td>Ac</td>
                <td>{{ data.data1.ac }}</td>
                <td>A</td>
              </tr>
            </table>
            <table>
              <tr>
                <td>Aa</td>
                <td>{{ data.data2.aa }}</td>
                <td>A</td>
              </tr>
              <tr>
                <td>Ab</td>
                <td>{{ data.data2.ab }}</td>
                <td>A</td>
              </tr>
              <tr>
                <td>Ac</td>
                <td>{{ data.data2.ac }}</td>
                <td>A</td>
              </tr>
            </table>
            <table>
              <tr>
                <td>Aa</td>
                <td>{{ data.data3.aa }}</td>
                <td>A</td>
              </tr>
              <tr>
                <td>Ab</td>
                <td>{{ data.data3.ab }}</td>
                <td>A</td>
              </tr>
              <tr>
                <td>Ac</td>
                <td>{{ data.data3.ac }}</td>
                <td>A</td>
              </tr>
            </table>
            <table>
              <tr>
                <td>Aa</td>
                <td>{{ data.data4.aa }}</td>
                <td>A</td>
              </tr>
              <tr>
                <td>Ab</td>
                <td>{{ data.data4.ab }}</td>
                <td>A</td>
              </tr>
              <tr>
                <td>Ac</td>
                <td>{{ data.data4.ac }}</td>
                <td>A</td>
              </tr>
            </table>
            <table>
              <tr>
                <td>Aa</td>
                <td>{{ data.data5.aa }}</td>
                <td>A</td>
              </tr>
              <tr>
                <td>Ab</td>
                <td>{{ data.data5.ab }}</td>
                <td>A</td>
              </tr>
              <tr>
                <td>Ac</td>
                <td>{{ data.data5.ac }}</td>
                <td>A</td>
              </tr>
            </table>
            <table>
              <tr>
                <td>Aa</td>
                <td>{{ data.data6.aa }}</td>
                <td>A</td>
              </tr>
              <tr>
                <td>Ab</td>
                <td>{{ data.data6.ab }}</td>
                <td>A</td>
              </tr>
              <tr>
                <td>Ac</td>
                <td>{{ data.data6.ac }}</td>
                <td>A</td>
              </tr>
            </table>
            <table>
              <tr>
                <td>Aa</td>
                <td>{{ data.data7.aa }}</td>
                <td>A</td>
              </tr>
              <tr>
                <td>Ab</td>
                <td>{{ data.data7.ab }}</td>
                <td>A</td>
              </tr>
              <tr>
                <td>Ac</td>
                <td>{{ data.data7.ac }}</td>
                <td>A</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
//这里可以导入其他文件(比如:组件,工具js,第三方插件js,json文件,图片文件等等)
//例如:import 《组件名称》 from '《组件路径》';
import {nextTick, onMounted, ref} from "vue";
import {getEveryOnceImgDataApi} from "@/api/modules/onceImg";
import {ElMessage} from "element-plus";
import qs from "qs";

// 一次图数据
let data = ref({
  "data1": {
    "aa": "",
    "ab": "",
    "ac": "",
    "ua": "",
    "ub": "",
    "uc": ""
  },
  "data2": {
    "aa": "",
    "ab": "",
    "ac": "",
    "ua": "",
    "ub": "",
    "uc": ""
  },
  "data3": {
    "aa": "",
    "ab": "",
    "ac": "",
    "ua": "",
    "ub": "",
    "uc": ""
  },
  "data4": {
    "aa": "",
    "ab": "",
    "ac": "",
    "ua": "",
    "ub": "",
    "uc": ""
  },
  "data5": {
    "aa": "",
    "ab": "",
    "ac": "",
    "ua": "",
    "ub": "",
    "uc": ""
  },
  "data6": {
    "aa": "",
    "ab": "",
    "ac": "",
    "ua": "",
    "ub": "",
    "uc": ""
  },
  "data7": {
    "aa": "",
    "ab": "",
    "ac": "",
    "ua": "",
    "ub": "",
    "uc": ""
  }
})

const resizeFun = function () {
  nextTick(() => {
    let ele = document.querySelector('.onceImgBgc')
    let scaleX = (ele.clientWidth) / 840
    let scaleY = (ele.clientHeight) / 630
    // document.querySelector('.bgcImg').style.transform = `scale(${scaleX},${scaleY})`
    for (let i = 0; i < document.querySelectorAll('.bgcImg').length; i++) {
      document.querySelectorAll('.onceImgBgc .bgcImg')[i].style.transform = `scale(${scaleX},${scaleY})`
    }
  })
}
onMounted(() => {
  nextTick(() => {
    resizeFun()
  })
  window.onresize = () => {
    resizeFun()
  }

  getEveryOnceImgDataApi(qs.stringify({
    type: 1
  })).then(res => {
    if (res.data.code === 0) {
      data.value = res.data.result
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message
      })
    }
  }).catch(err => {
    console.log(err);
  })
})
</script>

<style lang="less">
.onceItem1, .onceItem1 .onceImgBgc {
  width: 100%;
  height: 100% !important;

  .bgcImg {
    width: 840px;
    height: 630px;
    transform-origin: 0% 0%;
    position: relative;

    .bgc {
      width: 100%;
      height: 100%;
    }

    .tablePox {
      position: absolute;
      left: 11px;
      bottom: 60px;
      width: calc(100% - 22px);
      height: 164px;

      .tableItem {
        display: flex;
        justify-content: space-between;
        margin-bottom: 16px;
      }

      table {
        border: 0.5px solid #fff;
        border-collapse: collapse; /* 移除表格内边框间的间隙 */
        font-size: 9px;

        td {
          border: 0.5px solid #fff;
        }
      }

      table {
        width: 104px;
        height: 72px;


        tr {
          display: flex;
          height: 24px;
          align-items: center;

          td {
            height: 100%;
            line-height: 24px;
          }

          td:first-child {
            width: 22px;
            padding-left: 6px;
          }

          td:nth-child(2) {
            flex: 1;
            padding-left: 6px;
          }

          td:nth-child(3) {
            width: 22px;
            padding-left: 6px;
          }
        }

        tr:first-child {
          color: #F0F500;
        }

        tr:nth-child(2) {
          color: #00E834;
          flex: 1;
        }

        tr:nth-child(3) {
          color: #F90C0F;
        }
      }
    }

  }
}
</style>
